// extracted by mini-css-extract-plugin
export var arrowIcon = "desktopNavbarDropdown-module--arrowIcon--bc398";
export var clipout = "desktopNavbarDropdown-module--clipout--3e450";
export var dropdownContainer = "desktopNavbarDropdown-module--dropdownContainer--876d0";
export var dropdownContent = "desktopNavbarDropdown-module--dropdownContent--bc08d";
export var item = "desktopNavbarDropdown-module--item--c2e00";
export var link = "desktopNavbarDropdown-module--link--047eb";
export var overflowHidden = "desktopNavbarDropdown-module--overflow-hidden--8b9fc";
export var wrapper = "desktopNavbarDropdown-module--wrapper--a3a96";
export var wrapperInner = "desktopNavbarDropdown-module--wrapperInner--90f95";